import React from 'react';
import { ArrowDown } from 'lucide-react';

const Hero = () => {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-background">
        <img 
          src="https://images.unsplash.com/photo-1473830394358-91588751b241?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxjb250ZW1wbGF0aW9ufGVufDB8fHx8MTc3MTE4ODM4Mnww&ixlib=rb-4.1.0&q=85"
          alt="Contemplation"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <h1 className="hero-title">
          Mental and Emotional Health in Today's Hybrid Warfare Environment
        </h1>
        <p className="hero-subtitle">
          A call to resilience, clarity, and truth in an age of misinformation.
        </p>
        <div className="hero-meta">
          <span className="hero-author">By Daniel A. Stoescu</span>
          <span className="hero-date">Published May 25, 2025</span>
        </div>
        <div className="hero-cta">
          <button onClick={scrollToAbout} className="btn-primary">
            Learn More
          </button>
          <button onClick={() => document.getElementById('listen')?.scrollIntoView({ behavior: 'smooth' })} className="btn-secondary">
            Listen Now
          </button>
        </div>
      </div>
      
      <button onClick={scrollToAbout} className="scroll-indicator" aria-label="Scroll down">
        <ArrowDown size={32} />
      </button>
    </section>
  );
};

export default Hero;
